import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";

const KEY = "mm_favorites";
const FavoritesCtx = createContext(null);

export function FavoritesProvider({ children }) {
  const [ids, setIds] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY) || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(ids));
  }, [ids]);

  const toggle = useCallback((testId) => {
    setIds((cur) => (cur.includes(testId) ? cur.filter((i) => i !== testId) : [...cur, testId]));
  }, []);

  const has = useCallback((testId) => ids.includes(testId), [ids]);
  const clear = useCallback(() => setIds([]), []);

  const value = useMemo(() => ({ ids, toggle, has, clear }), [ids, toggle, has, clear]);

  return <FavoritesCtx.Provider value={value}>{children}</FavoritesCtx.Provider>;
}

export function useFavorites() {
  const ctx = useContext(FavoritesCtx);
  if (!ctx) throw new Error("useFavorites must be inside FavoritesProvider");
  return ctx;
}
